import TeamSelect from './TeamSelect';

export default TeamSelect;
